import React from "react";
import DynamicLayout from "../components/DynamicLayout";
import SaturnReturnExperience from "../components/tools/SaturnReturnExperience";
import '../assets/ascendant-display.sass';

const SaturnReturnPage = () => {
    return (
        <DynamicLayout>
            <SaturnReturnExperience />
        </DynamicLayout>
    );
};

export default SaturnReturnPage;
